<!-- =========================================================================================
    File Name: VxBreadcrumb.vue
    Description: Breadcrumb component
    Component Name: VxBreadcrumb
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-breadcrumb font-bold">
    <div class="flex flex-row items-center">
      <div class="flex items-center">
        <router-link to="/" class="my-auto">
          <font-awesome-icon
            class="home-icon stroke-current text-primary"
            :icon="['fal', 'home']"
          />
        </router-link>

        <feather-icon
          class="breadcrumb-separator mx-2"
          :icon="isRTL ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
          svgClasses="w-4"
        />
      </div>
      <div
        v-for="(link, index) in breadcrumbs.slice(1, -1)"
        :key="index"
        class="flex items-center"
      >
        <router-link :to="link.path" v-if="link.path">{{
          link.title
        }}</router-link>
        <span class="text-primary cursor-default" v-else>{{ link.title }}</span>
        <span class="breadcrumb-separator mx-2 flex items-start"
          ><feather-icon
            :icon="isRTL ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
            svgClasses="w-4"
        /></span>
      </div>
      <div class="flex">
        <span
          v-if="route.meta.breadcrumb.slice(-1)[0].active"
          class="cursor-default"
          >{{ route.meta.breadcrumb.slice(-1)[0].title }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vx-breadcrumb',
  props: {
    route: {},
    isRTL: {}
  },
  computed: {
    breadcrumbs() {
      return this.route.meta.breadcrumb.map(breadcrumb => {
        _.forOwn(this.route.params, (value, key) => {
          let keyValue = ':' + key;
          if(_.includes(breadcrumb.url, keyValue)) {
            breadcrumb.path = _.replace(breadcrumb.url, keyValue, value);
          }
        });

        return breadcrumb;
      });
    }
  }
};
</script>
